import { Node, mergeAttributes } from "@tiptap/core";
import { ReactNodeViewRenderer } from "@tiptap/react";
import { EquationNodeView } from "@/components/editor/nodeviews/EquationNodeView";

export const EquationBlock = Node.create({
  name: "equationBlock",
  group: "block",
  atom: true,

  addAttributes() {
    return {
      blockId: { default: null },
      latex: { default: "" },
      equationMode: { default: "display" },
      label: { default: "" },
      numbered: { default: true },
    };
  },

  parseHTML() {
    return [{ tag: 'div[data-type="equation-block"]' }];
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes, { "data-type": "equation-block" })];
  },

  addNodeView() {
    return ReactNodeViewRenderer(EquationNodeView);
  },
});
